/**
 * Labstep
 *
 * @module components/Thread/Item
 * @desc Thread
 */

import { CommentFormCreateCreateContainer as CreateComment } from 'labstep-web/components/Comment/Form/Create';
import { CommentListReadContainer as CommentList } from 'labstep-web/components/Comment/List';
import { scrollToBottom } from 'labstep-web/components/Thread/Modal';
import { MediaQueryMobile as Mobile } from 'labstep-web/core/MediaQuery/Mobile';
import type React from 'react';
import styles from './styles.module.scss';
import type {
  ThreadItemContainerProps,
  ThreadItemProps,
} from './types';

const ThreadItem: React.FC<ThreadItemProps> = ({
  thread,
  placeholder,
  noCommentsMessage,
  mobile,
  showCreateComment = true,
  autoFocus,
  ...rest
}) => (
  <div className={styles.content}>
    <div
      className={styles.commentList}
      data-cy="components/Thread/Item:commentList"
    >
      <CommentList
        noCommentsMessage={noCommentsMessage}
        threadId={thread.id}
        {...rest}
      />
    </div>
    {showCreateComment && (
      <div className={styles.create}>
        <CreateComment
          autoFocus={autoFocus}
          onSuccess={() => scrollToBottom(thread.id)}
          mobile={mobile}
          threadId={thread.id}
          placeholder={placeholder}
        />
      </div>
    )}
  </div>
);

export const ThreadItemContainer: React.FC<
  ThreadItemContainerProps
> = (props) => (
  <Mobile>
    {({ match }) => <ThreadItem {...props} mobile={match} />}
  </Mobile>
);
